export enum NotifyTypeIncludesEnum {
  ACTION_PLAN_APPROVAL = 'action_plan_approval',
  SECOND_ROUND_SUPPORT = 'second_round_support',
  ADHOC_APPROVAL = 'adhoc_approval',
  MEAL = 'meal',
}

export enum NoRedirectionNotifyTypeEnum {
  ACTION_PLAN_APPROVAL = 'action_plan_approval_request.updated',
  SECOND_ROUND_SUPPORT = 'second_round_support_approval_request.updated',
  ADHOC_APPROVAL = 'adhoc_approval_request.updated',
}
